import { ApiError } from '@teko/api';

const getError = (resp) => {
  const message = resp.message;
  return new ApiError(message, resp.code, resp);
};

export { getError };
